import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'velocity-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

// ReSharper disable once IdentifierTypo
  @Input() crumbcount: number = 3;
  @Input() breadcrumbs: any;

  ngOnInit() {

  }

}
